/// <amd-module name="typeahead/core/logging/TypeaheadInteractionMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";
import {Suggestion} from "typeahead/core/Suggestion";

export class TypeaheadInteractionMetric extends TypeaheadMetric {

    public readonly suggestionShown: boolean;
    public readonly suggestionSelected: boolean;
    public readonly isAddrAutocomplete: boolean;
    public readonly userTypedQuery: string;
    private inputLength: number;
    private selectionDepth: string;
    private childSuggestionsExpanded: boolean;
    private areChildrenPresent: boolean;

    constructor(lob: string, elementId: string, userTypedQuery: string, suggestionShown: boolean,
                selectedSuggestion: Suggestion, childSuggestionsExpanded: boolean,
                areChildrenPresent: boolean, activeESSTests: string) {

        super(lob, elementId, "TypeaheadInteraction", activeESSTests);

        this.suggestionShown = suggestionShown;
        this.userTypedQuery = userTypedQuery;
        this.inputLength = userTypedQuery.length;
        this.childSuggestionsExpanded = childSuggestionsExpanded;
        this.areChildrenPresent = areChildrenPresent;

        if (selectedSuggestion) {
            this.suggestionSelected = true;
            this.selectionDepth = selectedSuggestion.getPosition().toString();
            this.isAddrAutocomplete = selectedSuggestion.isAddrAutoComplete();
        } else {
            this.suggestionSelected = false;
            this.selectionDepth = "undefined";
            this.isAddrAutocomplete = false;
        }
    }
}
